




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

// UpdatorName interface
interface Request {
    updatedAt: string;
}

@Component({ components: { SimpleText } })
export default class UpdatedDate extends Vue {
    @Prop() public request!: Request;

    public static getNeededFields(): string[] {
        return [
            "request.updatedAt",
            "request.children.updatedAt",
        ];
    }
}
